module.exports = __webpack_public_path__ + "img/login.d4c5025d.png";